import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';

let enhancer;

if (process.env.NODE_ENV === 'development') {
	const logger = createLogger({
		level: 'info',
		collapsed: true,
	});

	enhancer = applyMiddleware(thunk, logger);
} else {
	enhancer = applyMiddleware(thunk);
}

export default function configureStore(initialState) {
	return createStore(rootReducer, initialState, enhancer);
}



// WEBPACK FOOTER //
// ./store/configureStore.js